import { gql } from 'graphql-request'

export const REMOVE_PAYMENT_QR = gql`
  mutation RemovePaymentQR($orderId: String!) {
    removePaymentQR(orderId: $orderId) {
      orderId
    }
  }
`
